<script>
import ProToast from '$common/ProToast'
import Loading from '$common/Loading'
import ModalsMain from '$modals/Main'
export default {
  name: 'App',
  components: {
    'pro-toast': ProToast,
    'loading': Loading,
    'modals-main': ModalsMain,
  },
  methods: {
    getEntities (uid) {
      return uid
    }
  },
  mounted () {
    console.log("app vue mounted")
  },
}
</script>


<template lang='pug'>
  #app
    modals-main
    router-view
    pro-toast
    loading
</template>

<style lang="sass">
  @import '$vars'
  body
    margin: 0
    font-family: $font-1
  #app
    position: relative
</style>
